"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThreeDots = exports.TailSpin = exports.SpinningCircles = exports.Rings = exports.Puff = exports.Oval = exports.Hearts = exports.Grid = exports.Circles = exports.Bars = exports.BallTriangle = exports.Audio = void 0;
/* istanbul ignore file */
var audio_1 = __importDefault(require("./components/audio"));
var ball_triangle_1 = __importDefault(require("./components/ball-triangle"));
var bars_1 = __importDefault(require("./components/bars"));
var circles_1 = __importDefault(require("./components/circles"));
var grid_1 = __importDefault(require("./components/grid"));
var hearts_1 = __importDefault(require("./components/hearts"));
var oval_1 = __importDefault(require("./components/oval"));
var puff_1 = __importDefault(require("./components/puff"));
var rings_1 = __importDefault(require("./components/rings"));
var spinning_circles_1 = __importDefault(require("./components/spinning-circles"));
var tail_spin_1 = __importDefault(require("./components/tail-spin"));
var three_dots_1 = __importDefault(require("./components/three-dots"));
exports.Audio = audio_1.default;
exports.BallTriangle = ball_triangle_1.default;
exports.Bars = bars_1.default;
exports.Circles = circles_1.default;
exports.Grid = grid_1.default;
exports.Hearts = hearts_1.default;
exports.Oval = oval_1.default;
exports.Puff = puff_1.default;
exports.Rings = rings_1.default;
exports.SpinningCircles = spinning_circles_1.default;
exports.TailSpin = tail_spin_1.default;
exports.ThreeDots = three_dots_1.default;
var LoadingIcons = {
    Audio: exports.Audio,
    BallTriangle: exports.BallTriangle,
    Bars: exports.Bars,
    Circles: exports.Circles,
    Grid: exports.Grid,
    Hearts: exports.Hearts,
    Oval: exports.Oval,
    Puff: exports.Puff,
    Rings: exports.Rings,
    SpinningCircles: exports.SpinningCircles,
    TailSpin: exports.TailSpin,
    ThreeDots: exports.ThreeDots,
};
exports.default = LoadingIcons;
